module.exports = __webpack_public_path__ + "static/media/icon-catalog-images.e6acc003.svg";